import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-stepper-dots',
    templateUrl: './stepper-dots.component.html',
    styleUrls: ['./stepper-dots.component.scss'],
    standalone: false
})
export class StepperDotsComponent {
  @Input() steps: number = 0;
  @Input() currentStep: number = 0;

  get stepArray(): number[] {
    return Array.from({ length: this.steps }, (_, i) => i);
  }

}